import type { NotesFilter } from '../../core/models/notes';

const actions = {
  SELECT: '[Notes] Select',
  ICON_CLICK: '[Notes] Icon Click',
  HOVER: '[Notes] Hover',
  SET_DATE_RANGE: '[Notes] Set date range',
  SET_CREATE_LOCATION: '[Notes] Set create location',
  SET_NOTES_FILTER: '[Notes] Set filter',
  SET_CREATE_FIELD: '[Notes] Set create field',
  SET_NOTE_DASHBOARD: '[Notes] Set note dashboard',
  selectNote: (noteId: string) => ({
    type: actions.SELECT,
    payload: noteId,
  }),
  setCurrentSelectedNote: (noteID: string | undefined) => ({
    type: actions.ICON_CLICK,
    payload: noteID,
  }),
  setNotesCreateLocation: (location: string) => ({
    type: actions.SET_CREATE_LOCATION,
    payload: location,
  }),
  setNotesCreateField: (id: string | null) => ({
    type: actions.SET_CREATE_FIELD,
    payload: id,
  }),
  setNotesFilter: (filter: NotesFilter) => ({
    type: actions.SET_NOTES_FILTER,
    payload: filter,
  }),
  setNoteHover: (id: { id: string; origin: 'list' | 'map' } | undefined) => ({
    type: actions.HOVER,
    payload: id,
  }),
  setNoteDashboard: (id: string | null) => ({
    type: actions.SET_NOTE_DASHBOARD,
    payload: id,
  }),
};

export default actions;
